import React from "react";
import "./NnNote.scss"

class NnNote extends React.Component {

  constructor(props) {
    super(props);
    this.displayRef = React.createRef();
  }

  render() {
    const {displayLetters, displayTiming, index, note} = this.props;
    let css = this.props.active;
    let label = note.getDisplayName(displayLetters);
    return (
      <li className="note-and-lyric" index={index} ref={this.displayRef}>
        <div className={css ? 'note active' : 'note'}>
          {note.isTied ? <b>&nbsp;</b> : label}
          <span className={"note-time" + (!displayTiming ? " hidden" : "")}>/{note.displayDuration}</span>
        </div>
        <div className="lyric">{note.lyric === '' ? <b>&nbsp;</b> : note.lyric}</div>
      </li>
    );
  }

  componentDidMount() {
    this.props.note.actualWidth = this.displayRef.current.offsetWidth;
  }
}
export default NnNote;
